module.exports = __webpack_public_path__ + "media/packs/images/flags/IL-096f531cdd5d0569870769f69248537f.svg";